// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KfFl_","type":"styles_type__3Cssc","choices":"styles_choices__27w5p"};